export enum AddressVerificationServiceEnum {
  Y = 'Y', // Match
  N = 'N', // Does not match
  X = 'X' //  cardholder's bank does not support address verification service
}
